import styled from 'styled-components';
import { useCallback, useState } from 'react';
import { fullWidthCellClassName } from 'customer-data-properties/utils/fullWidthCellClassName';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const NoWrapDiv = styled.div.withConfig({
  displayName: "TruncateDiv__NoWrapDiv",
  componentId: "sc-104ki6a-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:has( .", ",[data-classname~='", "'] ){width:100%;}", ""], fullWidthCellClassName, fullWidthCellClassName, ({
  $rightAligned
}) => $rightAligned ? 'text-align: right; width: 100%;' : '');
const TruncateDiv = ({
  rightAligned,
  children
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const handleMouseEnter = useCallback(({
    currentTarget
  }) => {
    setIsTruncated(currentTarget.scrollWidth > currentTarget.clientWidth);
  }, []);
  const TooltipContent = useCallback(() => /*#__PURE__*/_jsx(View, {
    children: children
  }), [children]);
  return /*#__PURE__*/_jsx(Tooltip, {
    Content: TooltipContent,
    disabled: !isTruncated,
    maxInlineSize: "500px",
    children: /*#__PURE__*/_jsx(NoWrapDiv, {
      "data-test-id": "truncated-object-label",
      onMouseEnter: handleMouseEnter,
      $rightAligned: rightAligned,
      children: children
    })
  });
};
export default TruncateDiv;